import React from 'react';
import { Box, Toolbar } from '@mui/material';
// import ChatbotApplet from './ChatbotApplet';

const AppLayout = ({ topbar, children }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh',
        bgcolor: 'background.default'
      }}
    >
      {/* 1. The Fixed Topbar passed from App.js */}
      {topbar}

      {/* 2. Main Content Area */}
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          p: 0,
          overflow: 'auto',
          display: 'flex',
          flexDirection: 'column'
        }}
      >
        <Toolbar />
        {children}
      </Box>

      {/* 3. Chatbot Applet */}
      {/* <ChatbotApplet /> */}

    </Box>
  );
};

export default AppLayout;